/**
 * Spanish UI strings for shared components. Keys are shared with en.ts.
 *
 * Solo el "cromo" de la interfaz vive aquí. La redacción de cumplimiento
 * (alcance de licencias, divulgaciones, consentimiento) NUNCA se guarda en este
 * archivo; proviene de src/lib/legal/* para que un cambio legal no se desfase
 * entre idiomas.
 */
export const es = {
  "nav.language": "Idioma",
  "nav.english": "English",
  "nav.spanish": "Español",
  "nav.switchToSpanish": "Ver esta página en español",
  "nav.switchToEnglish": "View this page in English",
  "nav.startMyApproval": "Iniciar Mi Aprobación",
  "nav.call": "Llamar",
  "nav.menu": "Menú",
  "nav.toggleMenu": "Abrir/cerrar menú",
  "nav.home": "Inicio",
  "nav.seeAll": "Ver todo",
  "nav.mortgageLoans": "Préstamos Hipotecarios",
  "nav.investorJourney": "Camino del Inversionista",
  "nav.whereWeLend": "Dónde Prestamos",
  "nav.whereWeLendCta": "Condados y mercados que servimos",
  "nav.statesWeLendIn": "Estados en los que prestamos",
  "nav.licensingNote": "Licenciados en FL y CO · fines comerciales en otros",
  "nav.calculators": "Calculadoras",
  "nav.resources": "Recursos",
  "nav.businessSetup": "Configuración Empresarial",
  "nav.blog": "Blog",
  "nav.partners": "Socios",
  "nav.about": "Nosotros",
  "nav.contact": "Contacto",
  "nav.dscrPrograms": "Programas DSCR",
  "nav.loanOptionsByLocation": "Opciones de préstamo por ubicación",
  "nav.states": "Estados",
  "nav.allStatesCounties": "Todos los estados y condados donde prestamos",

  "common.readMore": "Leer más",
  "common.viewAll": "Ver todo",
  "common.programs": "programas",
  "common.state": "Estado",
  "common.city": "Ciudad",
  "common.county": "Condado",
  "common.updated": "Actualizado",
  "common.published": "Publicado",
  "common.reviewed": "Revisado",
  "common.source": "Fuente",
  "common.educationalOnly": "Información educativa únicamente",
  "common.loading": "Cargando…",
  "common.error": "Algo salió mal",
  "common.close": "Cerrar",
  "common.next": "Siguiente",
  "common.back": "Atrás",
  "common.submit": "Enviar",
  "common.optional": "Opcional",
  "common.required": "Requerido",

  "cta.startApplication": "Iniciar su solicitud completa",
  "cta.seeTodaysRates": "Ver Tasas de Hoy",
  "cta.talkToUs": "Hable con un oficial de préstamos con licencia",
  "cta.getYourRateQuote": "Obtenga Su Cotización de Tasa Personalizada",
  "cta.checkYourScenario": "Revise Su Escenario",

  "form.firstName": "Nombre",
  "form.lastName": "Apellido",
  "form.email": "Correo electrónico",
  "form.phone": "Teléfono",
  "form.message": "Mensaje",
  "form.submit": "Enviar",
  "form.submitting": "Enviando…",
  "form.required": "Requerido",
  "form.recordInterest": "Registrar mi interés",
  "form.preferredLanguage": "Idioma preferido",
  "form.preferredLanguageEnglish": "Inglés",
  "form.preferredLanguageSpanish": "Español",

  "newsletter.title": "Resumen para inversionistas",
  "newsletter.body":
    "Tendencias de tasas, actualizaciones de programas y notas de mercado local — un correo al mes.",
  "newsletter.emailPlaceholder": "Ingrese su correo electrónico",
  "newsletter.subscribe": "Suscribirse",

  "toc.title": "En esta página",
  "quickAnswer.title": "Respuesta rápida",
  "tldr.title": "Resumen",

  "ai.title": "Pregunte a Simply AI",
  "ai.placeholder": "Pregunte sobre préstamos DSCR…",
  "ai.popular": "Popular en esta página",
  "ai.disclaimer":
    "Las respuestas son informativas, generadas a partir de reglas de programas publicadas, y no son una aprobación de préstamo ni un compromiso de financiamiento.",

  "translation.notice":
    "Esta página es una traducción al español proporcionada como cortesía. Los documentos de préstamo, divulgaciones y el proceso de solicitud hipotecaria se proporcionan en inglés.",
} as const;
